module.exports = __webpack_public_path__ + "static/media/arbeitsmittel_ok.bb06614e.jpg";